package com.milta.feature.route.data.remote.dto

import com.milta.feature.route.domain.entity.RouteHistoryItem
import kotlinx.serialization.Serializable

/** Mirrors backend `RouteHistoryItemDto` — one row of `GET /api/v1/routes/history` (MIL-52, Screen A). */
@Serializable
data class RouteHistoryItemDto(
    val routeId: String,
    val date: String,
    val driverId: String,
    val driverFirstName: String,
    val driverLastName: String,
    val totalDeliveries: Int,
    val deliveredCount: Int,
    val failedCount: Int,
)

fun RouteHistoryItemDto.toDomain() = RouteHistoryItem(
    routeId = routeId,
    date = date,
    driverId = driverId,
    driverFirstName = driverFirstName,
    driverLastName = driverLastName,
    totalDeliveries = totalDeliveries,
    deliveredCount = deliveredCount,
    failedCount = failedCount,
)
